import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useUserStore from '../../store/user';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const user = useUserStore(state => state.user);
  const isManager = user?.isManager || false;

  const languages = [
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Español' },
    { code: 'fr', label: 'Français' },
    { code: 'pt', label: 'Português' },
    { code: 'ru', label: 'Русский' },
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language);

  const handleLanguageChange = (langCode: string) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('language', langCode);
  };

  // Use dark variant for manager theme (white background)
  // Use outline-light for regular theme (dark background)
  const dropdownVariant = isManager ? 'outline-secondary' : 'outline-light';

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant={dropdownVariant}
        size="sm"
        className={isManager ? 'border-secondary' : ''}
      >
        {currentLanguage?.label}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {languages.map(lang => (
          <Dropdown.Item
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            active={lang.code === i18n.language}
          >
            {lang.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageSwitcher;
